export default "__VITE_ASSET__89e2e81a__"